import { sfMedia } from "@unlikelystudio/commerce-connector"

import { sfFetchWrapper } from "~/lib/shopify/utils/sf-fetch-wrapper"

export type IGetShopifyCollection = Awaited<ReturnType<typeof getSfMedia>>

export const getSfMedia = sfFetchWrapper(sfMedia)("media")
